import React from 'react';

import { useOutrightsCountBySport } from '../../../hooks';
import { OutrightsBySportContext } from '../OutrightsBySportContext';
import OrganizationContainer from './OrganizationContainer';
import TournamentList from './TournamentList';
import useTournamentList from './useTournamentList';

const TournamentListContainer: React.FC = () => {
    const { sportItem, isGroupedByOrganization } = useTournamentList();

    const contextValue = useOutrightsCountBySport();

    if (!sportItem) return null;

    return (
        <OutrightsBySportContext.Provider value={contextValue}>
            {isGroupedByOrganization ? (
                <OrganizationContainer sportItem={sportItem} />
            ) : (
                <TournamentList items={sportItem.children} />
            )}
        </OutrightsBySportContext.Provider>
    );
};

export default React.memo(TournamentListContainer);
